import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home, Dna, Activity, ShieldCheck, Truck } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const activities = [{
  title: 'Artificial Insemination',
  description: 'Providing AI services to improve livestock genetics nationwide.',
  icon: Activity
}, {
  title: 'Breed Improvement',
  description: 'Developing superior livestock breeds adapted to local conditions.',
  icon: Dna
}, {
  title: 'Genetic Conservation',
  description: 'Conserving indigenous animal genetic resources for future generations.',
  icon: ShieldCheck
}, {
  title: 'Semen Production',
  description: 'Producing and distributing high-quality semen from elite sires.',
  icon: Truck
}];
export function NagrcdbPage() {
  return <>
      <Header data-id="element-1190" />
      <main className="flex-grow pt-[160px] md:pt-[148px] bg-gray-50 pb-20" data-id="element-1191">
        <div className="relative text-white py-32 md:py-48 overflow-hidden" data-id="element-1192">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1516467508483-a7212febe31a?w=1600&h=600&fit=crop")'
        }} data-id="element-1193"></div>
          <div className="absolute inset-0 bg-uganda-green/80" data-id="element-1194"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8" data-id="element-1195">
            <div className="flex items-center text-sm text-green-100 mb-6" data-id="element-1196">
              <Link to="/" className="hover:text-white flex items-center" data-id="element-1197">
                <Home className="w-4 h-4 mr-1" data-id="element-1198" /> Home
              </Link>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1199" />
              <span data-id="element-1200">Programs & Projects</span>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1201" />
              <span className="text-white font-medium" data-id="element-1202">NAGRC&DB</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-1203">NAGRC&DB</h1>
            <p className="text-lg text-green-50 max-w-3xl leading-relaxed" data-id="element-1204">
              National Animal Genetic Resources Centre and Data Bank.
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8 py-12" data-id="element-1205">
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 mb-12" data-id="element-1206">
            <h2 className="text-2xl font-bold text-uganda-black mb-4" data-id="element-1207">
              Our Mandate
            </h2>
            <p className="text-gray-600 leading-relaxed text-lg" data-id="element-1208">
              To establish a comprehensive national animal breeding program in
              Uganda, and to promote, regulate, and control the quality of
              animal genetic materials.
            </p>
          </div>

          <h2 className="text-2xl font-bold text-uganda-black mb-8" data-id="element-1209">
            Key Activities
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1210">
            {activities.map((activity, index) => {
            const Icon = activity.icon;
            return <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-1211">
                  <div className="w-12 h-12 bg-green-100 text-uganda-green rounded-lg flex items-center justify-center mb-4" data-id="element-1212">
                    <Icon className="w-6 h-6" data-id="element-1213" />
                  </div>
                  <h3 className="text-lg font-bold text-uganda-black mb-2" data-id="element-1214">
                    {activity.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-1215">
                    {activity.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </main>
      <Footer data-id="element-1216" />
    </>;
}